import Control from './Control';
import ellipseGroupHover from '../../img/ellipse_grouphover.png';
import ellipseHover from '../../img/ellipse_hover.png';
import ellipsePressed from '../../img/ellipse_pressed.png';
import ellipseRest from '../../img/ellipse_rest.png';

export default class DrawEllipse extends Control {
  constructor(store, dispatcher) {
    super({
      tooltip: 'DrawEllipse (1)',
      mode: 'DrawEllipse',
      srcRest: ellipseRest,
      srcGroup: ellipseGroupHover,
      srcHover: ellipseHover,
      srcDown: ellipsePressed,
    }, store, dispatcher);
  }
}